
export class DtoItemImagePostRes {
    public url: string | null = null;
}
